/* Isolated quiz measurement. Never reads answers, names, email or result qids. */
(function () {
  'use strict';
  if (window.WynchQuizAnalyticsV1) return;
  window.WynchQuizAnalyticsV1 = { version: 1 };
  var configNode = document.getElementById('wynch-quiz-analytics-config-v1');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  var quizIds = ['quiz', 'varlamov', 'demo-store-x-wynch', 'quiz-sugarshape'];
  var quiz = quizIds.indexOf(config.page) >= 0 && ['quiz', 'quiz_varlamov'].indexOf(config.template) >= 0 ? config.page : '';
  var root = quiz && document.querySelector('.quiz-page');
  var storeKey = 'wynch_quiz_sessions_v2', attributionKey = 'wynch_quiz_attribution_v1', cartKey = 'wynch_quiz_cart_snapshot_v1';
  var current = null, pending = null, chain = Promise.resolve(), attached = '', revoked = false;
  function allowed() { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed()); }
  function save() {
    var all = JSON.parse(sessionStorage.getItem(storeKey) || '{}');
    all[quiz] = current;
    sessionStorage.setItem(storeKey, JSON.stringify(all));
  }
  async function session() {
    if (!allowed() || !root) return null;
    if (current && Date.now() - current.start < 1800000) return current;
    if (pending) return pending;
    pending = (async function () {
      try {
        var all = JSON.parse(sessionStorage.getItem(storeKey) || '{}'), saved = all[quiz];
        if (saved && saved.quiz === quiz && typeof saved.token === 'string' && Number.isFinite(saved.start) && Date.now() - saved.start < 1800000 && Array.isArray(saved.sent)) current = saved;
        else {
          var response = await fetch(Shopify.routes.root + 'apps/wynch-email/quiz-session', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ version: 2, quiz: quiz, device: (/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ? 'mobile' : 'desktop') }), signal: AbortSignal.timeout(4000)
          });
          if (!response.ok) return null;
          var data = await response.json();
          if (data.quiz !== quiz || typeof data.token !== 'string' || !Number.isFinite(data.start)) return null;
          current = { quiz: quiz, token: data.token, start: data.start, sent: [] };
        }
        if (!allowed() || revoked) { current = null; return null; }
        save(); return current;
      } catch (_) { return null; }
    })();
    try { return await pending; } finally { pending = null; }
  }
  async function attach(attribution) {
    if (!allowed() || !attribution || typeof attribution.token !== 'string' || Date.now() - attribution.start > 86400000 || attached === attribution.token) return;
    try {
      var response = await fetch(Shopify.routes.root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _wynch_quiz_measurement: attribution.token } }), signal: AbortSignal.timeout(4000)
      });
      if (response.ok) { attached = attribution.token; inspectCart(await response.json(), attribution); }
    } catch (_) { /* Attribution errors cannot delay or alter quiz navigation. */ }
  }
  // The legacy theme's Axios cart flow does not publish Shopify cart events.
  // Its getSections()/refreshMiniCart() redraw #products-cart after success.
  // Compare authoritative cart responses, never infer an addition from a click.
  function inspectCart(cart, attribution) {
    if (!allowed() || !Array.isArray(cart.items)) return;
    var quantities = {};
    cart.items.forEach(function (item) {
      if (String(item.variant_id) === '53372382708040' || item.properties?._wynch_club_cava || item.properties?._wynch_item_role === 'gift' || item.properties?._wynch_added_by === 'automatic') return;
      if (Number.isSafeInteger(item.variant_id) && Number.isSafeInteger(item.quantity)) quantities[item.variant_id] = (quantities[item.variant_id] || 0) + item.quantity;
    });
    var previous = JSON.parse(sessionStorage.getItem(cartKey) || 'null');
    if (previous && previous.token === attribution.token && previous.quantities && Object.keys(quantities).some(function (id) { return quantities[id] > (previous.quantities[id] || 0); })) {
      if (Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('wynch_quiz_v1', { version: 1, token: attribution.token, stage: 'added' });
    }
    sessionStorage.setItem(cartKey, JSON.stringify({ token: attribution.token, quantities: quantities }));
  }
  var cartTimer, cartPending = false;
  function scheduleCart() {
    if (!allowed()) return;
    clearTimeout(cartTimer);
    cartTimer = setTimeout(async function () {
      if (cartPending || !allowed()) return;
      var attribution;
      try { attribution = JSON.parse(sessionStorage.getItem(attributionKey) || 'null'); } catch (_) { return; }
      if (!attribution || Date.now() - attribution.start > 86400000) return;
      cartPending = true;
      try {
        var response = await fetch(Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(4000) });
        if (response.ok && allowed()) inspectCart(await response.json(), attribution);
      } catch (_) {} finally { cartPending = false; }
    }, 100);
  }
  var cartRoot = document.getElementById('products-cart');
  if (cartRoot) new MutationObserver(scheduleCart).observe(cartRoot, { childList: true, subtree: true });
  document.addEventListener('cart:refresh', scheduleCart);
  document.addEventListener('cart:updated', scheduleCart);
  function emit(stage) {
    if (!allowed()) return;
    chain = chain.then(async function () {
      var value = await session();
      if (!value || !allowed() || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;
      if (value.sent.indexOf(stage) < 0) {
        Shopify.analytics.publish('wynch_quiz_v1', { version: 1, token: value.token, stage: stage });
        value.sent.push(stage); save();
      }
      if (stage === 'finished') {
        var attribution = { token: value.token, start: value.start };
        sessionStorage.setItem(attributionKey, JSON.stringify(attribution));
        await attach(attribution);
      }
    }).catch(function () {});
  }
  function visible(el) {
    for (var node = el; node && node !== root.parentElement; node = node.parentElement) {
      if (node.hidden || node.hasAttribute('x-cloak') || getComputedStyle(node).display === 'none' || getComputedStyle(node).visibility === 'hidden') return false;
    }
    return true;
  }
  function check() {
    if (!root || !allowed() || document.visibilityState !== 'visible' || !visible(root)) return;
    emit('opened');
    if (Array.from(root.querySelectorAll('.quiz-page-question')).some(visible)) emit('started');
  }
  function start() {
    if (!allowed()) return;
    revoked = false;
    check();
    try {
      var attribution = JSON.parse(sessionStorage.getItem(attributionKey) || 'null');
      if (attribution && Date.now() - attribution.start < 86400000) attach(attribution);
      else sessionStorage.removeItem(attributionKey);
    } catch (_) {}
  }
  if (root) {
    new MutationObserver(check).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'x-cloak'] });
    document.addEventListener('quiz:finished', function () { emit('finished'); });
    document.addEventListener('questions:generated', check);
  }
  document.addEventListener('visibilitychange', check);
  document.addEventListener('visitorConsentCollected', function () {
    if (allowed()) start();
    else {
      revoked = true; current = null; attached = '';
      try { sessionStorage.removeItem(storeKey); sessionStorage.removeItem(attributionKey); sessionStorage.removeItem(cartKey); } catch (_) {}
    }
  });
  var attempts = 0;
  (function ready() { start(); if ((!window.Shopify || !Shopify.customerPrivacy) && ++attempts < 40) setTimeout(ready, 250); })();
})();
